import React from "react";
import { Trash2 } from "lucide-react";

import { TAB_TYPES } from "../../constants";

/**
 * Delete Confirmation Modal
 */
const DeleteModal = ({
  isOpen,
  activeTab,
  itemToDelete,
  isLoading,
  onConfirm,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="bg-app-bg w-full max-w-md mx-3 rounded-2xl border border-app-border shadow-2xl overflow-hidden animate-in zoom-in-95 duration-200">
        <div className="p-6 text-left">
          <h3 className="text-[15px] font-semibold text-[#FEFCEB] mb-2">
            {`Delete ${activeTab === TAB_TYPES.TEAMS ? "team" : "member"} ${itemToDelete?.name}`}
          </h3>
          <p className="text-app-text-secondary text-[13px] mb-6">
            Are you sure you want to remove{" "}
            <strong className="text-[#FEFCEB]">{itemToDelete?.name}</strong> from
            this competition? This action cannot be undone.
          </p>

          <div className="flex items-center justify-end gap-3">
            <button
              onClick={onClose}
              className="px-6 py-2.5 bg-app-card rounded-full text-app-text hover:bg-[#1e3a57] transition-colors text-sm font-medium"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              disabled={isLoading}
              className="px-6 py-2.5 rounded-full bg-app-error hover:bg-red-600 text-blue-shade-8 text-sm font-medium transition-colors disabled:opacity-50"
            >
              {isLoading ? "Deleting..." : "Delete"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
